// Ensure the class is not redeclared if it's already defined
if (typeof SearchForm === 'undefined') {
  // Define the class as a global variable to avoid let/const redeclaration issues
  window.SearchForm = class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.resetButton = this.querySelector('button[type="reset"]');

      // Properly bind methods to keep 'this' context and remove listeners later
      this.handleInput = this.handleInput.bind(this);
      this.handleReset = this.handleReset.bind(this);

      if (this.input) {
        this.input.form.addEventListener('reset', this.handleReset);
        this.input.addEventListener('input', this.debounce(this.handleInput, 300));
      }
    }

    connectedCallback() {
      // Optionally add DOM-related or state initialization here
      this.toggleResetButton();
    }

    disconnectedCallback() {
      // Remove event listeners to prevent memory leaks
      if (this.input) {
        this.input.form.removeEventListener('reset', this.handleReset);
        this.input.removeEventListener('input', this.debounce(this.handleInput, 300));
      }
    }

    toggleResetButton() {
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }

    handleInput() {
      this.toggleResetButton();
    }

    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a');
    }

    handleReset(event) {
      // Prevent the form from resetting to initial values
      event.preventDefault();
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
        this.toggleResetButton();
      }
    }

    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
  };

  // Define the custom element if it hasn't been defined yet
  if (!customElements.get('search-form')) {
    customElements.define('search-form', window.SearchForm);
  }
}
